import * as React from 'react';
import { useMarketInsightsStore } from '@/src/market-insights/store';
import { Pagination } from './Pagination';

export const MarketInsightsPagination = React.memo(() => {
  const { currentRange, updateRange, listings } = useMarketInsightsStore(state => ({
    currentRange: state.range,
    updateRange: state.updateRange,
    listings: state.listings,
  }));
  return <Pagination listings={listings} currentRange={currentRange} onUpdateRange={updateRange} />;
});
